import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import styles from '../../style.module.scss'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { handleApiError } from '@shared-submodule/utils'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

import F1HallOfFameDetail from '@shared/components/f1HallOfFameDetail'
import Layout from '@shared/components/layout'
import queryGraphql from '@shared/components/queryGraphql'
import { GRAPHQL_URL } from '@shared-submodule/sm-constants'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

function HallOfFameDetailPage({ hallOfFameDetailData, seo, removeAds }) {
  const { addTop, mobSm, addBottom, addLeft } = reviveAdData
  return (
    <Layout data={{ oSeo: seo }}>
      <div className={`${styles.details_page_container} container md:px-0 pb-5`}>
        {!removeAds && (
          <div className="w-full d-none d-xl-flex justify-content-center my-3">
            <ReviveAds {...addTop} className={'my-3'} />
          </div>
        )}
        {!removeAds && (
          <div className="w-full d-flex d-xl-none justify-content-center my-1">
            <ReviveAds {...mobSm} className={'my-1'} />
          </div>
        )}
        <F1HallOfFameDetail hallOfFameDetailData={hallOfFameDetailData} />
        {!removeAds && (
          <div className="w-full d-flex d-xl-none justify-content-center my-2">
            <ReviveAds {...addLeft} className={'my-2'} />
          </div>
        )}
        {!removeAds && (
          <div className="w-full d-none d-xl-flex justify-content-center my-3">
            <ReviveAds {...addBottom} className={'my-3 text-center'} />
          </div>
        )}
      </div>
    </Layout>
  )
}

HallOfFameDetailPage.propTypes = {
  hallOfFameDetailData: PropTypes.object,
  removeAds: PropTypes.bool,
  seo: PropTypes.object
}

export default HallOfFameDetailPage

export async function getServerSideProps({ res, resolvedUrl, params }) {
  const { slug } = params
  try {
    const baseUrl = GRAPHQL_URL.replace(/\/graphql$/, '')
    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: `formula1-racing/hall-of-fame/drivers/${slug}` } })

    const urlDriver = new URL(`${baseUrl}/api/global-widget/f1/hall-of-fame/driver/${seo?.getSeoData?.iId}`)

    const teamDetailResponse = await fetch(urlDriver, {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    })
    const hallOfFameDetailData = await teamDetailResponse.json()

    return {
      props: {
        hallOfFameDetailData: hallOfFameDetailData || {},
        seo: seo?.getSeoData || {}
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
